import { AllCombinedProductLines } from 'self-service-api/constants/AllCombinedProductLines';
import { MARKETING, OPERATIONS } from 'self-service-api/constants/ProductLines';
import { RECOMMENDED_OPS_HUB } from 'self-service-api/constants/RecommendedHubs';
import { FetchRecommendedHubRequestTypes } from '../actions/RecommendedHubActions';
import { makeRequestStatusSelector } from './RequestStatusSelectors';
export const fetchRecommendedHubStatus = makeRequestStatusSelector(FetchRecommendedHubRequestTypes.REQUEST);
export const recommendedHubNameSelector = state => {
  const recommendedHubData = state.recommendedHub;
  let recommendedHubName = recommendedHubData && recommendedHubData.recommendedHub;

  // OPS -> OPERATIONS
  if (RECOMMENDED_OPS_HUB === recommendedHubName) {
    recommendedHubName = OPERATIONS;
  }
  const isProductLine = AllCombinedProductLines.some(productLine => productLine === recommendedHubName);
  return isProductLine ? recommendedHubName : MARKETING;
};